import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContactService } from '../../../services/api/contact.service';
import { Configuration } from 'src/app/models/configurations/configuration';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { translate } from '@jsverse/transloco';
@Component({
    selector: 'app-report-issue',
    templateUrl: './report-issue.component.html',
    styleUrls: ['./report-issue.component.scss'],
    standalone: false
})
export class ReportIssueComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;
  @Input() report: any;
  @Input() configurations: Configuration[];
  @Input() buildNumber: any;
  @Input() version: any;
  @Input() releaseVersion: any; 
  @Input() isAMR: boolean;
private destroyRef = inject(DestroyRef);
  reportIssueForm: FormGroup;


  Constants = Constants;
  sent: boolean;
  typedMessage = '';
  messageSentTry = false;
  sendBtnClicked = false;
  notApplicable = translate('INSTANCE_SUMMARY.NA');

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService, private contactService: ContactService,
     private authService: AuthService) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  reportIssue(): any {
    if (!FormUtilService.validateForm(this.reportIssueForm)) {
      return;
    }
    const report = this.reportIssueForm.getRawValue();
    this.sidenavService.closeRightSidenav(report);
    this.typedMessage = this.reportIssueForm.get('message').value;
    this.sendBtnClicked = true;
    this.contactService.sendMessage(this.reportIssueForm.getRawValue())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
          this.sent = true;
          this.messageSentTry = true;
      },
        (error) => {
          this.sent = false;
          this.messageSentTry = true;
        }
      );
  }
  /**
   * Prepares the report issue form
   * As of now jira is not available so we are following the email configuration for this report issue
   */
  private createForm(): void {
    const userInfo = this.authService.principal;
    const companyName = userInfo.attributes.issuerName || userInfo.attributes.issuerId || userInfo.provider;

    this.reportIssueForm = this.formBuilder.group({
      name: [userInfo.attributes.name, Validators.required],
      email: [userInfo.attributes.email, Validators.required],
      company: [companyName, Validators.required],
      buildNumber: [this.buildNumber?this.buildNumber : this.notApplicable],
      version: [this.version?this.version : this.notApplicable],
      releaseVersion:[this.releaseVersion? this.releaseVersion : this.notApplicable],
      environment: [this.report?.instance?.environment? this.report?.instance?.environment : this.notApplicable],
      dataZone: [this.report?.instance?.dataZone],
      releasePackageVersion: [this.report?.instance?.activeConfiguration?.manifest?.version?
        this.report?.instance?.activeConfiguration?.manifest?.version :  this.notApplicable],
      message: [this.report.description != null ? this.report.description : '', Validators.required]
    });
  }

  /**
   * Validates the form and if the validation results successful, the
   * sidenav service is closed and we get the report object
   */
}
